import React from "react";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";
const useStyles = makeStyles(styles);

export default function FollowUpStatement() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8}>
            <h2>
              Get your auto-generated plans for <b>free forever</b> for the 50
              first early adopters!
            </h2>
            <h4>
              Waking up to a fresh plan designed by you is still an idea in the
              making, and the prototype is still in development. For that
              reason, early adopters are crucial for the evolution of Live
              Planner and a lifetime subscription is our way to say thank you.
            </h4>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
